import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-engine-report-amra',
  templateUrl: './engine-report-amra.component.html',
  styleUrls: ['./engine-report-amra.component.scss']
})
export class EngineReportAmraComponent implements OnInit {

  constructor() { }

  isHoursReadGreaterThan10000 : boolean = true;
  
  ngOnInit() {
  }

}
